import ScheduleContent from './component'

export default ScheduleContent